import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import CommonModal from "./modal";
import "./video-modal-wrapper.scss";

const VideoModalWrapper = ({ videoId, videoWidth, videoHeight, autoplay, title, icon }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = useCallback(() => {
    setIsOpen(prevIsOpen => !prevIsOpen);
  }, []);

  const aspectRatioPercentage = (videoHeight / videoWidth) * 100;
  const autoplayParam = autoplay ? 1 : 0;
  const videoSrc = `https://www.youtube.com/embed/${videoId}?enablejsapi=1&autoplay=${autoplayParam}`;

  const modalBody = (
    <div>
      <div
        style={{
          position: "relative",
          paddingBottom: `${aspectRatioPercentage}%`,
          height: 0
        }}
      >
        <iframe
          id={`youtube-iframe-${videoId}`}
          title="YouTube Video"
          width="100%"
          height="100%"
          src={videoSrc}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{
            position: "absolute",
            top: 0,
            left: 0
          }}
        />
      </div>
    </div>
  );

  return (
    <div>
      <button
        id="video-link"
        style={{ all: "unset", cursor: "pointer" }}
        onClick={toggleModal}
        type="button"
      >
        <div className="btn-container">
          <div className="btn-content">
            <div className="icon">
              <i className={`fa fa-${icon}`} aria-hidden="true" />
            </div>
            <div className="btn-text">{title}</div>
          </div>
        </div>
      </button>
      <CommonModal
        isOpen={isOpen}
        toggleModal={toggleModal}
        modalBody={modalBody}
        modalSize="lg"
        headerClassName=""
        modalHeader={null}
        className="video-modal"
      />
    </div>
  );
};

VideoModalWrapper.propTypes = {
  videoId: PropTypes.string.isRequired,
  videoWidth: PropTypes.number,
  videoHeight: PropTypes.number,
  autoplay: PropTypes.bool,
  title: PropTypes.string,
  icon: PropTypes.string
};

VideoModalWrapper.defaultProps = {
  videoWidth: 560,
  videoHeight: 315,
  autoplay: false,
  title: "Watch Video",
  icon: "play-circle"
};

export default VideoModalWrapper;
